import React from "react";
import moment from "moment-timezone";

export default function TableMobileComponent({
  headers = {},
  list = [],
  pageNo = 1,
  size = 10,
  options = {}
}) {
  return (
    <div className="min-w-full space-y-4">
      {list?.length > 0 ? (
        list.map((ele, index1) => (
          <div
            key={index1}
            className={`flex flex-col p-4 rounded-lg shadow-lg space-y-2 border border-gray-200 ${options?.trRowBg || ele?.className || "bg-[#FFFFFF]"
              }`}
          >
            {Object.keys(headers).map((key, index) => {
              if (key === "SN") return null;
              return (
                <div key={index} className="text-sm flex justify-between">
                  <span className="font-medium text-gray-600 w-24 whitespace-nowrap">
                    {headers[key]}
                  </span>

                  <span className="text-gray-900 text-right mr-2  text-wrap overflow-hidden overflow-x-auto">
                    {key === "createdAt" || key === "updatedAt" ? (
                      moment(ele[key]).format("DD.MM.YYYY hh:mm A")
                    ) : ele[key] === null || ele[key] === undefined ? (
                      "N/A"
                    ) : React.isValidElement(ele[key]) ? (
                      <div className="inline-block">{ele[key]}</div>
                    ) : (
                      ele[key].toString()
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        ))
      ) : (
        <div className="p-4 rounded-lg shadow-lg border border-gray-200 text-center">
          <div className="w-fit mx-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              version="1.1"
              width={200}
              height={200}
              x={0}
              y={0}
              viewBox="0 0 68 68"
              style={{ enableBackground: "new 0 0 512 512" }}
              xmlSpace="preserve"
              className=""
            >
              <g>
                <path
                  d="M21.5 38.6c.3-.3.3-.8 0-1.1l-2.4-2.4 3.1-3.1c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L18 34l-2.8-2.8c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l2.8 2.8-2.8 2.8c-.3.3-.3.8 0 1.1s.8.3 1.1 0l2.8-2.8 2.4 2.4c.4.3.8.3 1.1 0zM21.2 48.5c-.3.3-.3.8.1 1.1.3.3.8.3 1.1-.1 4.9-5.4 13.3-5.3 18.1-.3.3.3.8.3 1.1 0s.3-.8 0-1.1c-5.5-5.6-14.9-5.7-20.4.4z"
                  fill="#9ca3af"
                  opacity="0.2"
                  data-original="#000000"
                  className=""
                />
                <path
                  d="M58.6 54.5 61.2 28c.1-1.1-.3-2.2-1-3s-1.8-1.3-2.9-1.3v-6.9c0-2.6-2-4.7-4.6-4.8l-42.1-.6c-2.7 0-4.7 2.1-4.8 4.6v1.8c-1.2.3-2.1 1.1-2.6 2.3-.6.7-1 1.6-1.2 2.3-.5 1.8-.4 3.7-.2 5.6.8 8.8 1.6 17.5 2.3 26.3.3 3.8 1.3 5.4 6.8 5.7 15.7.8 31.4.7 47.1.4.6 0 1.3 0 1.8-.3.6-.3 1-.9.9-1.5-.3-1.3-2.5-1.1-3.8-1.2.9-.6 1.5-1.6 1.7-2.9zM10.6 13l42.1.6c1.7 0 3.2 1.5 3.1 3.2v7H41.1c-1.1 0-2.2-.5-3-1.3l-2.3-2.6c-1.2-1.3-2.9-2.1-4.7-2.1H7.3v-1.6c0-1.9 1.5-3.3 3.3-3.2zm44.1 43.6H9.6c-1.2 0-2.3-.9-2.4-2.2L4.3 21.8c-.1-1.4 1-2.6 2.4-2.6h24.4c1.4 0 2.7.6 3.6 1.6l2.3 2.6c1 1.2 2.5 1.9 4.1 1.9h16.2c.7 0 1.3.3 1.8.8s.7 1.2.6 1.8l-2.6 26.5c-.1 1.2-1.2 2.2-2.4 2.2z"
                  fill="#9ca3af"
                  opacity="0.2"
                  data-original="#000000"
                  className=""
                />
                <path
                  d="m44.2 33.8 2.2-2.2c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.2 2.2-2.8-2.8c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l2.8 2.8-2.6 2.6c-.3.3-.3.8 0 1.1s.8.3 1.1 0l2.6-2.6 2.8 2.8c.3.3.8.3 1.1 0s.3-.8 0-1.1zM57.8 7.6c-.9 1.2-1.6 2.4-2.1 3.8-.1.4.1.8.5.9s.8-.1.9-.5c.4-1.2 1-2.4 1.8-3.4.3-.3.2-.8-.1-1.1-.3 0-.7 0-1 .3zM64.2 10.5c-.2-.3-.7-.5-1-.2l-4.7 3c-.3.2-.4.7-.2 1s.7.5 1 .2l4.7-3c.3-.2.4-.7.2-1zM65.6 15.9l-5.3.4c-.4 0-.7.4-.7.8s.4.7.8.7l5.3-.4c.4 0 .7-.4.7-.8-.1-.4-.4-.7-.8-.7z"
                  fill="#9ca3af"
                  opacity="0.2"
                  data-original="#000000"
                  className=""
                />
              </g>
            </svg>
            <p className="text-gray-400 text-xl font-medium capitalize">
              Data Not Found
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
